import { FC } from 'react'

import { AssignmentLateOutlineRoundedIcon } from '@/components/icons'

import { IDataNotFoundProps } from './types'

const DataNotFound: FC<IDataNotFoundProps> = ({
  text = 'Tudo limpo por aqui',
}) => {
  return (
    <div className="flex flex-col w-full justify-center items-center p-8 gap-4">
      <AssignmentLateOutlineRoundedIcon className="fill-primary w-32 h-32" />
      <h4 className="prose-headline-h6 text-neutral-black">{text}</h4>
    </div>
  )
}

export default DataNotFound
